import { createContext } from "react";

// APP
export interface IAppContext {
  bootstrapped?: boolean;
  config?: IConfig;
  topScores?: Array<ITopScore>;
  setData?: (data: IAppContext) => void;
}
export interface IConfig {
 
}

export interface ITopScore {
  firstName: string;
  lastName: string;
  carColor: CarColors;
  concertType: ConcertTypes;
  score: number;
  key: string;
}

export const AppContextDefaults: IAppContext = {
  bootstrapped: false,
  config: {},
  // topScores: [],
};

export const AppContext = createContext<IAppContext>({});

export enum Locations {
  MA = "Massachusetts",
  CT = "Connecticut",
}

export enum Distance {
  Massachusetts = "3,099",
  Connecticut = "3,007",
}

export enum CarColors {
  WHITE = "White",
  GREEN = "Green",
  BLUE = "Blue",
  ORANGE = "Orange",
}

export enum ConcertTypes {
  ROCK = "Rock",
  POP = "Pop",
  COUNTRY = "Country",
}

// PROFILE
export interface IProfileContext {
  firstName?: string;
  lastName?: string;
  location?: Locations;
  carColor?: CarColors;
  concertType?: ConcertTypes;
  happiness: number;
  time: number;
  battery: number;
  timeBonus: number;
  currentChallenge: number;
  score?: number;
  key?: string;
  setProfile?: (profile: Partial<IProfileContext>) => void;
  clearProfile?: () => void;
  getValues?: (values?: IProfileValues) => IProfileValues;
}

export const ProfileContextDefaults = {
  // Defaults
  firstName: "",
  lastName: "",
  carColor: CarColors.WHITE,
  happiness: 0,
  time: 0,
  battery: 0,
  timeBonus: 0,
  currentChallenge: 0,
  score: 0,
  topScores: [],

  // // Testing
  // firstName: "David",
  // lastName: "Cha",
  // carColor: CarColors.GREEN,
  // concertType: ConcertTypes.ROCK,
  // location: Locations.MA,
  // happiness: 10,
  // time: 0,
  // battery: 80,
  // timeBonus: 1000,
  // currentChallenge: 16,
  // score: -1,
  // topScores: [],
};

export const ProfileContext = createContext<IProfileContext>(ProfileContextDefaults);
